define(['readingiq-src/js/config/levels-config'], function tagModelServiceImpl(
  levelsConfig
) {
  'use strict';

  var tagModelService = function tagModelService(riqApiService, $q) {
    var _this = this;
    var READING_LEVEL_MAP = levelsConfig.maps.groupReadingLevels.camelToSnake;

    riqApiService.setApiEndpoints({
      getTag: 'tag_get'
    });

    // eslint-disable-next-line valid-jsdoc
    /**
     * Get Tags Info
     * @param {Array} data An array of enum Levels
     */
    var getTag = function getTag(data) {
      return riqApiService.userGet('getTag', {tagTypes: data}, true);
    };

    var _handleGetTagLevelOptions = function _handleGetTagLevelOptions(
      payload
    ) {
      var levelOptions = {
        gradeOptions: payload[0].tags,
        guidedReadingOptions: payload[1].tags,
        lexileOptions: null,
        acceleratedReaderOptions: payload[3].tags
      };
      return levelOptions;
    };

    var getTagLevelOptions = function getTagLevelOptions() {
      var gradeOptions = getTag([READING_LEVEL_MAP.gradeLevel]);
      var guidedReadingOptions = getTag([READING_LEVEL_MAP.guidedLevel]);
      var lexileOptions;
      var acceleratedReaderOptions = getTag([
        READING_LEVEL_MAP.acceleratedReaderLevel
      ]);

      return $q
        .all([
          gradeOptions,
          guidedReadingOptions,
          lexileOptions,
          acceleratedReaderOptions
        ])
        .then(_handleGetTagLevelOptions)
        .catch(function(error) {
          throw error;
        });
    };

    _this.getTag = getTag;
    _this.getTagLevelOptions = getTagLevelOptions;
  };

  return tagModelService;
});
